import { useContext } from 'react';

import { WorkflowErrorContext, WorkflowErrorContextValue } from '../contexts/WorkflowErrorContext';

// Default values when used outside the provider (e.g., in ExecutionCanvas, WorkflowPreviewCanvas)
const defaultContextValue: WorkflowErrorContextValue = {
  showErrors: false,
  setShowErrors: () => {},
  nodeErrors: [],
  workflowErrors: [],
  getNodeErrors: () => [],
};

/**
 * Hook to access workflow error state (error display, validation results).
 *
 * When used outside of WorkflowErrorContext provider (e.g., in ExecutionCanvas, WorkflowPreviewCanvas),
 * returns safe defaults with no errors displayed.
 *
 * @example
 * ```tsx
 * const { showErrors, nodeErrors, getNodeErrors } = useWorkflowError();
 *
 * const myErrors = getNodeErrors(nodeId);
 * const hasErrors = showErrors && myErrors.length > 0;
 * ```
 */
export function useWorkflowError(): WorkflowErrorContextValue {
  const context = useContext(WorkflowErrorContext);

  // Return defaults when outside provider (e.g., ExecutionCanvas, WorkflowPreviewCanvas use same node renderers)
  return context ?? defaultContextValue;
}
